import { styled } from '@mui/material/styles';
import Table from 'components/OpportunitiesTable';

export const OpportunitiesTable = styled(Table)(({ theme }) => ({
  borderRadius: theme.borderRadius.base,
  boxShadow: theme.boxShadow.base
}));
